module.exports = __webpack_public_path__ + "static/YYP-08d220463384c5b65e8bc8d50fdc93c6.png";